import { Component, OnInit } from '@angular/core';
import { AwardsService } from '../awards.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayService } from '../../../shared/display.service';
import { Location } from '@angular/common';
import { CurrencyService } from '../../../shared/currency.service';
import { AnalyticsService } from 'src/app/shared/analytics/analytics.service';
import { UrlService } from '../../../shared/url.service';

@Component({
  selector: 'app-awards-details',
  templateUrl: './awards-details.component.html',
  styleUrls: ['./awards-details.component.scss']
})
export class AwardsDetailsComponent implements OnInit {

  awardsKeyData: any[];

  constructor(
    private awardsService: AwardsService,
    private route: ActivatedRoute,
    private location: Location,
    public displayService: DisplayService,
    public analyticsService: AnalyticsService,
    private router: Router,
    public currencyService: CurrencyService,
    public urlService: UrlService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    this.route.params.subscribe(p => {
      this.awardsService.getAwardsByKey(p.awardKey)
        .subscribe(data => {
          this.awardsKeyData = data;
        });
    });
  }

  getDocumentUrl(uniqueNumber: string): string {
    return this.urlService.getClientSiteUrl(uniqueNumber);
  }

  goBack() {
    this.location.back();
  }

  hideReservePriceTable(award: any): boolean {
    return !award.reservePrice && !award.restrictionsBidders && !award.spectrumCapRules;
  }

  hideAccessTable(award: any): boolean {
    return !award.accessMVNOs && !award.accessServiceProviders && !award.accessNationalRoaming;
  }

  hideObligationsTable(award: any): boolean {
    return !award.coverageObligations && !award.otherObligations;
  }

  hidePriceTable(award: any): boolean {
    return !award.mhzOffered && !award.mhzOfferedComment && !award.mhzAwarded && !award.mhzAwardedComment && !award.pricePaid && !award.pricePaidComment && award.awardbands.length === 0;
  }

  isSpectrumLightContent(value: string) {
    if (value === 'BLUR_CONTENT') {
      return '<p class="SpectrumLight">Upgrade...</p>';
    } else if (value === 'Beauty_Contest') {
      return 'Beauty contest';
    } else {
      return value;
    }
  }

  isSpectrumLightComment(value: string) {
    if (value === 'BLUR_COMMENT') {
      return '';
    } else {
      return value;
    }
  }

  getLicenceLink(countryCode: string, bandName: string): string {
    const modifiedBandName = bandName.replace(/Hz.*/, 'Hz').replace(/\s/g, '').replace(/\./g, '-');
    return '/licences/country/' + countryCode + '/band/' + modifiedBandName;
  }
}

